export default __webpack_public_path__ + "static/media/brick.7b6ecaa9.jpg";